//searchResultPremium
import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withCookies } from "react-cookie";
import * as actionTypes from "../../store/actions/actionTypes";
import { openAPI } from "../../config";

const getFontWeight = (props, viewing) => {
  if (viewing !== 15) {
    return props.itemOnPage === viewing
      ? { fontWeight: 700 }
      : { fontWeight: 400 };
  } else {
    return props.itemOnPage === viewing || props.itemOnPage === 12
      ? { fontWeight: 700 }
      : { fontWeight: 400 };
  }
};

const saveVendorData = (props, dataFor, result, leadgencookies) => {
  switch (dataFor) {
    case "testimonials":
      if (!leadgencookies) {
        props.saveVendorTestimonialsData(result);
      }
      if (leadgencookies) {
        if (
          !!props.vendorProfile.visitor.method.email ||
          !!props.vendorProfile.visitor.method.linkedin
        ) {
          props.saveVendorTestimonialsData({
            ...result,
            num_unblurred_reviews: -1,
          });
        }
      }
      break;
    case "case-studies":
      if (!leadgencookies) {
        props.saveVendorCaseStudiesData(result);
      }
      if (leadgencookies) {
        if (
          !!props.vendorProfile.visitor.method.email ||
          !!props.vendorProfile.visitor.method.linkedin
        ) {
          props.saveVendorCaseStudiesData({
            ...result,
            num_unblurred_reviews: -1,
          });
        }
      }
      break;
    case "customer-videos":
      if (!leadgencookies) {
        props.saveVendorVideoData(result);
      }
      if (leadgencookies) {
        if (
          !!props.vendorProfile.visitor.method.email ||
          !!props.vendorProfile.visitor.method.linkedin
        ) {
          props.saveVendorVideoData({
            ...result,
            num_unblurred_reviews: -1,
          });
        }
      }
      break;
    default:
      break;
  }
};

const searchResultPremium = (props) => {
  const { cookies } = props;
  const URLRegexPatternALL = new RegExp("/all$");

  const getDataSet = (count) => {
    let tempURL = `${props.location.pathname.replace(/\/all/, "")}${
      props.location.search
    }`;
    if (props.location.search) {
      if (tempURL.includes("p=")) {
        tempURL = tempURL.replace(/&p=(\d+)?/, "");
        tempURL = tempURL.replace(/p=(\d+)?/, "");
      }
      props.history.push(`${tempURL}`);
      tempURL = `${tempURL}&view=${count}`;
    } else {
      tempURL = `${tempURL}?view=${count}`;
    }

    openAPI
      .get(`${process.env.REACT_APP_API_URL}${tempURL}`, {
        withCredentials: true,
      })
      .then((response) => {
        const valueOfLeadGen = !!props.vendorProfile.visitor;
        props.toggleLoader();
        const location = props.location.pathname.split("/");
        let onTab;
        if (props.location.pathname.includes("/all")) {
          onTab = location[location.length - 2];
        } else {
          onTab = location[location.length - 1];
        }
        saveVendorData(props, onTab, response.data, valueOfLeadGen);
      });
  };

  return (
    <React.Fragment>
      <div className="total_results">
        <span className="bold_txt">
          {`${props?.paginationInfo?.start_index}-${props?.paginationInfo?.end_index}`}
        </span>
        {` `}
        of <span>{props?.totalReviewCount?.toLocaleString()}</span> results
      </div>
    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveVendorTestimonialsData: (data) =>
      dispatch({
        type: actionTypes.SAVE_VENDOR_TESTIMONIAL_DATA,
        payload: data,
      }),
    saveVendorCaseStudiesData: (data) =>
      dispatch({
        type: actionTypes.SAVE_VENDOR_CASESTUDIES_DATA,
        payload: data,
      }),
    saveVendorVideoData: (data) =>
      dispatch({ type: actionTypes.SAVE_VENDOR_VIDEOS_DATA, payload: data }),
  };
};

const searchResultPremiumWithRouter = withRouter(
  withCookies(searchResultPremium)
);

export default connect(null, mapDispatchToProps)(searchResultPremiumWithRouter);
